import { useState, useEffect } from 'react';

const SCALER_ID = 'auto-scaler';
const DESIGN_WIDTH = 1024;
const MOBILE_BREAKPOINT = 1024;

export const useAutoScaler = (): { isContentReady: boolean } => {
  const [isContentReady, setIsContentReady] = useState(false);

  useEffect(() => {
    const updateScale = () => {
      const viewportWidth = window.innerWidth;

      const scaler = document.getElementById(SCALER_ID);
      const scalerWrapper = scaler?.parentElement;

      if (scaler && scalerWrapper) {
        if (viewportWidth <= MOBILE_BREAKPOINT) {
          scaler.style.transform = 'none';
          scaler.style.width = '100%';
          scalerWrapper.style.height = 'auto';
        } else {
          const scale = viewportWidth / DESIGN_WIDTH;

          scaler.style.transform = 'none';

          let totalHeight = 0;
          Array.from(scaler.children).forEach((child) => {
            const el = child as HTMLElement;
            const marginTop = parseInt(window.getComputedStyle(el).marginTop) || 0;
            const marginBottom = parseInt(window.getComputedStyle(el).marginBottom) || 0;
            totalHeight += el.offsetHeight + marginTop + marginBottom;
          });

          scaler.style.transform = `scale(${scale})`;
          scaler.style.transformOrigin = 'top center';
          scaler.style.width = `${DESIGN_WIDTH}px`;

          scalerWrapper.style.height = `${totalHeight * scale}px`;
        }
      }
    };

    let contentReadySet = false;

    const handleLoad = () => {
      updateScale();
      if (!contentReadySet) {
        contentReadySet = true;
        setIsContentReady(true);
      }
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    const fallbackTimeout = setTimeout(() => {
      if (!contentReadySet) {
        updateScale();
        contentReadySet = true;
        setIsContentReady(true);
      }
    }, 2000);

    window.addEventListener('resize', updateScale);

    const scaler = document.getElementById(SCALER_ID);
    let resizeObserver: ResizeObserver | null = null;
    if (scaler) {
      resizeObserver = new ResizeObserver(() => {
        updateScale();
      });
      resizeObserver.observe(scaler);
      Array.from(scaler.children).forEach((child) => {
        resizeObserver!.observe(child);
      });
    }

    return () => {
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('resize', updateScale);
      clearTimeout(fallbackTimeout);
      resizeObserver?.disconnect();
    };
  }, []);

  return { isContentReady };
};
